// 9fbef606107a605d69c0edbcd8029e5d
import googleMapConstants from '@tcp/core/src/constants/googleMap.constants';
import { getTranslatedDate } from './OrderListWithDetails.utils';
import constants from '../../../Orders.constants';

const { STATUS_CONSTANTS = {} } = constants;
const { ITEM_READY_FOR_PICK_UP } = STATUS_CONSTANTS;

/**
 * This function component use for return the Order item list based on group
 * can be passed in the component.
 * @param otherProps - otherProps object used for showing Order Item list
 */
export const openStoreDirections = (orderSummary) => {
  const { shippingAddress } = orderSummary;
  const { addressLine1, city, state, zipCode } = shippingAddress;
  try {
    if (window) {
      window.open(
        `${googleMapConstants.OPEN_STORE_DIR_WEB}${addressLine1},%20${city},%20${state},%20${zipCode}`,
        '_blank',
        'noopener'
      );
    }
  } catch (error) {
    console.log(error);
  }
};

export const getMaxQuantityToBeShown = (isMobile) => (isMobile ? 5 : 8);

export const getShipDateForReadyForPickUpOrder = (
  shipment,
  isBOSSOrder,
  packageStatus,
  isBOSSOrderStatusEnabled,
  shipDate
) => {
  let extractedShipDate = '';
  if (
    isBOSSOrder &&
    isBOSSOrderStatusEnabled &&
    packageStatus === ITEM_READY_FOR_PICK_UP &&
    !shipDate
  ) {
    const readyForPickUpShipDate = shipment.items[0].trackingInfo[0].shipDate;
    extractedShipDate = getTranslatedDate(readyForPickUpShipDate);
  }
  return extractedShipDate;
};

export const formEddObject = (
  packageStatus,
  isBOSSOrderStatusEnabled,
  extractedShipDate,
  shipDate,
  actualDeliveryDate,
  orderDate
) => {
  return {
    shipDate:
      packageStatus === ITEM_READY_FOR_PICK_UP && isBOSSOrderStatusEnabled
        ? extractedShipDate
        : shipDate,
    actualDeliveryDate,
    orderDate,
  };
};
